'use strict';

var _ = require('lodash');
var FareLadderChart = function FareLadderChart(AbstractChart, rectangleWithText, faresOptimizerFareTooltipService) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var CHART_HEIGHT_PADDING = 30;
  var CHART_WIDTH_PADDING = 15;
  var FARE_BOX_WIDTH_DEFAULT_PADDING = 15.5;
  var FARE_BOX_WIDTH_ADJUSTED_PADDING = 18;
  var OVERLAP_HEIGHT_ADJUSTMENT = 23;
  var INITIAL_FARE_BOX_Y_COORDINATE = 2;
  function ladderDetailsTooltip(data) {
    return faresOptimizerFareTooltipService.renderFareTooltipWithSharedFbc(data.toolTipContent);
  }
  function updateFareBoxCoordinates(data, params) {
    var sortedFares = _.sortBy(data, 'totalFare');
    _.forEach(sortedFares, function (value, currentFareIndex) {
      var roundedTotalFare = Math.round(value.totalFare);
      var currentFareBoxWidth = getFareBoxWidth(roundedTotalFare);
      var adjustedWidthForScaling = params.width - getFareBoxWidth(value.fareRange[1]) - CHART_WIDTH_PADDING;
      var scales = chartScales(adjustedWidthForScaling, value.fareRange);
      var currentFareBoxStartPosition = scales.xScale(roundedTotalFare);
      if (currentFareIndex > 0 && isCurrentFareBoxOverlapping(sortedFares, currentFareBoxStartPosition, currentFareIndex)) {
        value.x = currentFareBoxStartPosition;
        value.y = sortedFares[currentFareIndex - 1].y + OVERLAP_HEIGHT_ADJUSTMENT;
        value.width = currentFareBoxWidth;
      } else {
        value.x = currentFareBoxStartPosition;
        value.width = currentFareBoxWidth;
      }
    });
  }
  function isCurrentFareBoxOverlapping(data, currentFareBoxStartPosition, currentFareIndex) {
    if (isPrecedingFareBoxNotOverlapping(data, currentFareBoxStartPosition, currentFareIndex)) {
      return false;
    }
    if (isPrecedingFareBoxAtStartLine(data, currentFareIndex)) {
      return true;
    }
    var index = indexOfPreviousFareBoxesPositionedAtStartLine(data, currentFareIndex);
    if (currentFareBoxStartPosition < data[index].x + getFareBoxWidth(Math.round(data[index].totalFare))) {
      return true;
    }
  }
  function isPrecedingFareBoxNotOverlapping(data, currentFareBoxStartPosition, currentFareIndex) {
    var precedingFareBoxEndPosition = data[currentFareIndex - 1].x + getFareBoxWidth(Math.round(data[currentFareIndex - 1].totalFare));
    return currentFareBoxStartPosition > precedingFareBoxEndPosition;
  }
  function isPrecedingFareBoxAtStartLine(data, currentFareIndex) {
    return data[currentFareIndex - 1].y === INITIAL_FARE_BOX_Y_COORDINATE;
  }
  function indexOfPreviousFareBoxesPositionedAtStartLine(data, index) {
    for (var i = index - 1; i >= 0; i--) {
      if (data[i].y === INITIAL_FARE_BOX_Y_COORDINATE) {
        return i;
      }
    }
  }
  function getFareBoxWidth(totalFare) {
    var roundedTotalFare = Math.round(totalFare);
    var totalFareLength = roundedTotalFare.toString().length;
    if (totalFareLength <= 3) {
      return totalFareLength * FARE_BOX_WIDTH_ADJUSTED_PADDING;
    }
    return totalFareLength * FARE_BOX_WIDTH_DEFAULT_PADDING;
  }
  var Chart = function Chart(container) {
    AbstractChart.call(this, container);
    var fareLadderRectangle = rectangleWithText(ladderDetailsTooltip).params(this.params).scales(this.scales);
    var containerHeight = function containerHeight(data) {
      if (data) {
        return _.maxBy(data.fareLadderData, 'y').y + CHART_HEIGHT_PADDING;
      }
    };
    this.render = function (data) {
      var params = chartParams();
      updateFareBoxCoordinates(data.fareLadderData, params(this.container.width(), this.container.height()));
      this.setDataPropertyName('fareLadderData');
      fareLadderRectangle.withData(data.fareLadderData);
      this.initChart(data, undefined, chartParams(containerHeight(data)));
      this.callForDataGroup([fareLadderRectangle]);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
FareLadderChart.$inject = ['AbstractChart', 'RectangleWithText', 'FaresOptimizerFareTooltipService'];
module.exports = FareLadderChart;